import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'
import FYIClientDto from './FYIClientDto'

export namespace FYIDto {
   export const accessTokenSchema = z.object({
      accessId: z.string({ errorMap }).min(1),
      accessSecret: z.string({ errorMap }).min(1),
   })
   export type accessToken = z.output<typeof FYIDto.accessTokenSchema>

   export type clientMinimal = Pick<FYIClientDto, 'id' | 'name'> & { uuid: FYIClientDto['details']['uuid'] }
}
